import { datajsAll } from '../shared/utils';
import Swiper, { FreeMode, Mousewheel, Navigation } from 'swiper';

export default class NavsAndTabs {
	static init() {
		const navCarousels = datajsAll('nav-carousel');

		if (navCarousels.length === 0) {
			return;
		}

		// Fix carousels inside each active tab
		const tabNabButtons = datajsAll('tab-nav-btn');
		if (tabNabButtons && tabNabButtons.length) {
			tabNabButtons.forEach((btn) => {
				btn.addEventListener('shown.bs.tab', (event) => {
					const tab = document.querySelector(event.target.dataset.bsTarget);

					if (tab) {
						const carousels = datajsAll('carousel-block', tab);
						const promoCarousels = datajsAll('promo-carousel', tab);
						const cardCollections = datajsAll('card-collection', tab);
						const fiftyFiftySliders = datajsAll('fiftyfifty-slider', tab);

						const allCarousels = [...carousels, ...promoCarousels, ...cardCollections, ...fiftyFiftySliders];

						allCarousels.forEach((carousel) => {
							carousel.swiper?.update();
							carousel.swiper?.updateProgress();
						});
					}
				});
			});
		}

		navCarousels.forEach((carousel) => {
			this.setupSwiperInstance(carousel);
		});
	}

	static setupSwiperInstance(carousel) {
		// eslint-disable-next-line no-new
		new Swiper(carousel, {
			modules: [FreeMode, Mousewheel, Navigation],
			speed: 500,
			slidesPerView: 'auto',
			freeMode: true,
			spaceBetween: 0,
			mousewheel: {
				forceToAxis: true,
			},

			navigation: {
				nextEl: '[data-js~=carousel-next]',
				prevEl: '[data-js~=carousel-prev]',
			},
		});
	}
}
